// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"_0dc94a1","open":"_68457af","icon":"_1902493"};